import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import QuotMaterialView from '../../SaleTables/View/QuotMaterialView.jsx';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Button,
    Grid, Paper, Checkbox, Typography
} from '@mui/material';

import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';

import { fetchQuotViewlist } from '../../../Store/PHPSlice/Sale/Quotation';
import { fetchItemMaterialData } from '../../../Store/PHPSlice/Item';

import {
    selectQuotView,
    selectItemMaterialData
} from '../../Selectors/Master/ItemSelectors';

const QuotMaterialViewEntry = () => {
const [showMaterialView, setShowMaterialView] = useState(false);
    const { Id, itemId } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();

    const viewlist = useSelector(selectQuotView);
    const itemMaterialdata = useSelector(selectItemMaterialData);

    const [materialList, setMaterialList] = useState([]);
    const [selectedMaterials, setSelectedMaterials] = useState([]);
    const [formData, setFormData] = useState({
    quotNo: '',
    itemNm: '',
    partyNm: ''
});
const [quotationData, setQuotationData] = useState({});

    /* FETCH DATA */

    useEffect(() => {
        dispatch(fetchItemMaterialData(itemId));
    }, [Id, itemId, dispatch]);

    useEffect(() => {
        if (itemMaterialdata?.data) {
            setMaterialList(itemMaterialdata.data);
        }
    }, [itemMaterialdata]);



    /* CHECKBOX */
    const baseUrl = process.env.REACT_APP_BASE_URL;
useEffect(() => {

    const fetchData = async () => {

        try {

            const response = await axios.get(
                `${baseUrl}?apicall=getQuotationlist1&qtId=${Id}`
            );

            const result = response.data;

            console.log("API RESULT", result);

            if (result.data) {

                setFormData({
                    quotNo: result.data.quotNo,
                    itemNm: result.data.itemNm,
                    partyNm: result.data.partyNm
                });

            }

        } catch (error) {
            console.error("Error fetching quotation:", error);
        }

    };

    if(Id){
        fetchData();
    }

}, [Id]);
 const handleMaterialSelect = (material) => {

    const exists = selectedMaterials.some(m => m.ID === material.ID);

    if (exists) {

        setSelectedMaterials(selectedMaterials.filter(m => m.ID !== material.ID));

    } else {

        setSelectedMaterials([
            ...selectedMaterials,
            {
                ID: material.ID,
                matId: material.matId,
                materialNm: material.materialNm,
                sizewise: material.sizewise || []
            }
        ]);

    }

};
    /* SUBMIT */

  const handleSubmit = async () => {

    try {

        const payload = {
            quotId: Id,
            item: itemId,
            materialArr: selectedMaterials
        };

        console.log("Sending Data =>", payload);

        const res = await axios.post(
            `${baseUrl}?apicall=saveQuotationMaterial`,
            payload
        );

        alert(res.data.msg);
       // window.close();
               setShowMaterialView(true);   // 👈 show component


    } catch (error) {

        console.error("Error saving materials:", error);
        alert("Error saving materials");

    }

};
    //console.log("viewlist=>",viewlist,"Id=>",Id);
    return (

        <Grid container justifyContent="center">

            <Grid item xs={12} md={10}>

                <Paper elevation={5} sx={{ p: 3 }}>

                    <div ref={componentRef}>

                        <Typography
                            variant="h5"
                            align="center"
                            sx={{
                                fontWeight: "bold",
                                mb: 3,
                                color: "#1976d2"
                            }}
                        >
                            Quotation Material View Entry
                            <hr style={{border:"2px dashed #000"}}/>
                        </Typography>

                        {/* QUOTATION DETAILS */}

<Grid container spacing={2} sx={{ mb: 2 }}>

    <Grid item xs={12} sm={4}>
        <Typography variant="subtitle2" fontWeight="bold">
            Quotation No :
        </Typography>
        <Typography variant="body1">
            {formData.quotNo}
        </Typography>
    </Grid>

    <Grid item xs={12} sm={4}>
        <Typography variant="subtitle2" fontWeight="bold">
            Item Name :
        </Typography>
        <Typography variant="body1">
            {formData.itemNm}
        </Typography>
    </Grid>

    <Grid item xs={12} sm={4}>
        <Typography variant="subtitle2" fontWeight="bold">
            Party Name :
        </Typography>
        <Typography variant="body1">
            {formData.partyNm}
        </Typography>
    </Grid>

</Grid>

                        <TableContainer>

                            <Table size="small" sx={{ border: "1px solid #000" }}>

                                <TableHead>

                                    <TableRow sx={{ backgroundColor: "#1976d2" }}>

                                        <TableCell sx={{ color: "#fff", fontWeight: "bold", textAlign: "center",border: "1px solid #000" }}>
                                            Select
                                        </TableCell>

                                        <TableCell sx={{ color: "#fff", fontWeight: "bold", textAlign: "center",border: "1px solid #000" }}>
                                            Sr.No
                                        </TableCell>

                                        <TableCell sx={{ color: "#fff", fontWeight: "bold",border: "1px solid #000" }}>
                                            Material Name
                                        </TableCell>

                                        <TableCell sx={{ color: "#fff", fontWeight: "bold",border: "1px solid #000" }}>
                                            Size Details
                                        </TableCell>

                                    </TableRow>

                                </TableHead>

                                <TableBody>

                                    {materialList?.length > 0 ? (

                                        materialList.map((item, index) => (

                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff"
                                                }}
                                            >

                                                <TableCell align="center" sx={{border: "1px solid #000"}}>

                                                    <Checkbox
                                                        checked={selectedMaterials.some(m => m.ID === item.ID)}
                                                        onChange={() => handleMaterialSelect(item)}
                                                    />

                                                </TableCell>

                                                <TableCell align="center" sx={{border: "1px solid #000"}}>
                                                    {index + 1}
                                                </TableCell>

                                                <TableCell sx={{border: "1px solid #000"}}>
                                                    <Typography fontWeight="600">
                                                        {item.materialNm}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell  sx={{border: "1px solid #000"}}>

                                                    {item?.sizewise?.length > 0 ? (

                                                        <Table
                                                            size="small"
                                                            sx={{
                                                                border: "1px solid #000"
                                                            }}
                                                        >

                                                            <TableBody>

                                                                <TableRow sx={{ background: "#f0f0f0" }}>
                                                                    <TableCell sx={{ fontWeight: "bold" ,border:"1px solid #000"}}>
                                                                        Size
                                                                    </TableCell>

                                                                    {item.sizewise.map((s, i) => (
                                                                        <TableCell key={i} align="center" sx={{border:"1px solid #000"}}>
                                                                            {s.size}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>

                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "bold",border:"1px solid #000" }}>
                                                                        Material Size
                                                                    </TableCell>

                                                                    {item.sizewise.map((s, i) => (
                                                                        <TableCell key={i} align="center" sx={{border:"1px solid #000"}}>
                                                                            {s.matsize}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>

                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "bold",border:"1px solid #000" }}>
                                                                        Qty
                                                                    </TableCell>

                                                                    {item.sizewise.map((s, i) => (
                                                                        <TableCell key={i} align="center" sx={{border:"1px solid #000"}}>
                                                                            {s.qty}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>

                                                            </TableBody>

                                                        </Table>

                                                    ) : "-"}
                                                </TableCell>

                                            </TableRow>

                                        ))

                                    ) : (

                                        <TableRow>
                                            <TableCell colSpan={4} align="center" sx={{border:'1px solid #000'}}>
                                                Material has not been assigned for this quotation.
                                            </TableCell>
                                        </TableRow>

                                    )}

                                </TableBody>

                            </Table>

                        </TableContainer>

                    </div>

                    {/* BUTTONS */}

                    <Grid
                        container
                        spacing={2}
                        sx={{ mt: 3 }}
                        justifyContent="center"
                    >

                        <Grid item>

                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleSubmit}
                                sx={{ px: 4 }}
                            >
                                Submit 
                            </Button>

                        </Grid>
<hr style={{borderBottom:"2px dashed #000"}}/>                     {/* {showMaterialView && ( */}
    <Grid container sx={{ mt: 4 }}>
        <Grid item xs={12}>
            <QuotMaterialView quotId={Id}  />
        </Grid>
    </Grid>
{/* )} */}

                    </Grid>

                </Paper>

            </Grid>

        </Grid>

    );
};

export default QuotMaterialViewEntry;